import { render, staticRenderFns } from "./NewInterfaceSwitch.vue?vue&type=template&id=b5668a94&scoped=true&"
import script from "./NewInterfaceSwitch.vue?vue&type=script&lang=ts&"
export * from "./NewInterfaceSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5668a94",
  null
  
)

export default component.exports